<!-- Spacer -->
<div
    class="hemro-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
